/* eslint-disable react/forbid-prop-types */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ExpandCollapse } from '@tds/core-expand-collapse';
import Modal from '../design/shared/modal';
import { customStyles } from './css';

import UpdateOrder from './updateOrder';
import Note from '../note';
import FormSummaryGroup from '../form/formSummaryGroup';

const OrderDetails = ({
  open,
  setOpen,
  order,
  onSave,
  userRights,
  assignees,
  comments,
  summary,
  isSalesManager,
  isSalesSupport
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      order={order}
      customStyles={customStyles}
      header={_.get(order, 'orderId', '')}
    >
      <div className="container 85%">
        <UpdateOrder
          order={order}
          setOpen={setOpen}
          open={open}
          onSave={onSave}
          users={assignees}
          userRights={userRights}
          comments={comments}
          isSalesManager={isSalesManager}
          isSalesSupport={isSalesSupport}
        >
          <ExpandCollapse topDivider={false}>
            {summary &&
              summary.map(({ fields }) => {
                const { note, formSummaryGroup, title } = fields;
                return (
                  <ExpandCollapse.Panel key={title} id={title} header={title}>
                    <>
                      {note && note.content && (
                        <Note data={note} type="richText" />
                      )}
                      <FormSummaryGroup
                        data={formSummaryGroup}
                        orderData={order}
                      />
                    </>
                  </ExpandCollapse.Panel>
                );
              })}
          </ExpandCollapse>
        </UpdateOrder>
      </div>
    </Modal>
  );
};

OrderDetails.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  userRights: PropTypes.object.isRequired,
  comments: PropTypes.arrayOf(PropTypes.object),
  assignees: PropTypes.object,
  summary: PropTypes.object.isRequired,
  isSalesManager: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired
};

OrderDetails.defaultProps = {
  onSave: null,
  assignees: null,
  comments: null
};

export default OrderDetails;
